export default __webpack_public_path__ + "static/media/Reh.1be0fdc7.png";